import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ExtendedFaqItem, FaqItem } from '@core/models/faq.model';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  animations: [
    trigger('toggleItem', [
      state('in', style({ height: '*' })),
      state('out', style({ height: '0' })),
      transition('in <=> out', animate('250ms ease'))
    ])
  ],
  standalone: true,
  imports: [CommonModule]
})
export class FaqComponent implements OnInit {
  public indexActive = 0;
  public answer: SafeHtml;
  public faqListFormated: ExtendedFaqItem[] = [];

  @Input() set faqList(list: FaqItem[]) {
    this.faqListFormated = list.map(item => ({ ...item, answerHtml: this.domSanitizer.bypassSecurityTrustHtml(item.answer) }))
  }
  @Input() faqType: 'product' | 'faq-page' = 'product';
  @Input() isShowArrow = false;
  @Input() isOpenFirstQA = true;

  constructor(
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    if (this.isOpenFirstQA) {
      this.openFirstQA();
    }
  }

  openFirstQA(): void {
    if (this.faqListFormated.length) {
      this.faqListFormated[0].isOpened = true;
    }
  }

  toggleFaqIndex(index: number): void {
    this.faqListFormated[index].isOpened = !this.faqListFormated[index].isOpened;
    this.indexActive = index;
  }
}
